import type { AnyObj } from '@/types';
import { toast } from '@/utils';
// #ifdef H5
import WechatSDK from 'weixin-js-sdk';
// #endif

export default async (wxchatPayment: AnyObj) => {
  try {
    const paymentRes: any = await pay(wxchatPayment);
    if (paymentRes?.errMsg === 'requestPayment:ok') {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    toast.message('支付失败');
  }
};

const pay = (params: AnyObj) => {
  return new Promise((resolve, reject) => {
    WechatSDK.ready(function () {
      WechatSDK.chooseWXPay({
        timestamp: params.timeStamp + '',
        nonceStr: params.nonceStr,
        package: params.package,
        signType: params.signType,
        paySign: params.paySign,
        success: (res: AnyObj) => {
          resolve(res);
        },
        fail: (err: AnyObj) => {
          resolve(err);
        },
        cancel: () => {
          resolve({});
        },
      });
    });

    WechatSDK.error(function (err: any) {
      reject(err);
    });
  });
};
